import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './auth/AuthProvider'
import { LoginPage } from './pages/LoginPage'
import { AdminShell } from './components/shell/AdminShell'
import { DashboardPage } from './pages/DashboardPage'
import { OrdersPage } from './pages/OrdersPage'
import { OrderDetailPage } from './pages/OrderDetailPage'
import { AdminOrderCreatePage } from './pages/AdminOrderCreatePage'
import { InventoryPage } from './pages/InventoryPage'
import { BlogPage } from './pages/BlogPage'
import { BlogPostEditor } from './pages/BlogPostEditor'
import { FaqAdminPage } from './pages/FaqAdminPage'
import { UsersPage } from './pages/UsersPage'
import { AuthorProfilePage } from './pages/AuthorProfilePage'
import { AffiliatesPage } from './pages/AffiliatesPage'
import { AffiliateDetailPage } from './pages/AffiliateDetailPage'
import { ProductsPage } from './pages/ProductsPage'
import { ProductEditorPage } from './pages/ProductEditorPage'
import { AdminHeroPage } from './pages/AdminHeroPage'
import { CategoriesPage } from './pages/CategoriesPage'
import { ContactPage } from './pages/ContactPage'
import { SettingsPage } from './pages/SettingsPage'
import { ReviewsPage } from './pages/ReviewsPage'
import { TestimonialsPage } from './pages/TestimonialsPage'
import { VideoTestimonialsPage } from './pages/VideoTestimonialsPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  // Admin and author roles both get into the SPA. Authors only see
  // blog-related pages (enforced by route-level checks). Orders,
  // Users, etc. stay admin-only.
  if (!user || (user.role !== 'admin' && user.role !== 'author')) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AdminShell />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/new" element={<AdminOrderCreatePage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/new" element={<BlogPostEditor />} />
        <Route path="/blog/:id" element={<BlogPostEditor />} />
        <Route path="/faq" element={<FaqAdminPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:id/author" element={<AuthorProfilePage />} />
        <Route path="/affiliates" element={<AffiliatesPage />} />
        <Route path="/affiliates/:id" element={<AffiliateDetailPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/new" element={<ProductEditorPage />} />
        <Route path="/products/:slug" element={<ProductEditorPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/hero" element={<AdminHeroPage />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/testimonials" element={<TestimonialsPage />} />
        <Route path="/video-testimonials" element={<VideoTestimonialsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}